module.exports = __webpack_public_path__ + "img/6.fe41523f.jpg";